<template>
  <el-dropdown :hide-on-click="false" trigger="click" placement="bottom-end">
    <el-button type="info" style="margin-left: 10px">
      表示項目
      <font-awesome-icon icon="caret-down" style="margin-left: 5px" />
    </el-button>

    <el-dropdown-menu slot="dropdown" class="report-display-button-menu">
      <el-dropdown-item @click.native="resetReportItems()">初期値に戻す</el-dropdown-item>

      <template v-for="f in fields">
        <el-dropdown-item v-if="shouldShowField(f)" :key="f.column">
          <el-checkbox
              :value="isChecked(f.column)"
              :disabled="isDisabledField(f)"
              @change="onToggle(f.column, $event)"
          >
            {{ f.title }}
          </el-checkbox>
        </el-dropdown-item>
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
function normalizeSnsType(v) {
  const s = (v || "").toString().toLowerCase();
  if (s === "tiktok") return "tiktok";
  if (s === "x" || s === "twitter") return "x";
  return "instagram";
}
function normalizeListType(v) {
  return (v || "").toString() === "post" ? "post" : "influencer";
}

export default {
  name: "reportDisplayButton",
  props: {
    sns_type: { type: String, default: "instagram" },
    list_type: { type: String, default: "influencer" }, // 'influencer' | 'post'
  },
  computed: {
    st() {
      return normalizeSnsType(this.sns_type);
    },
    lt() {
      return normalizeListType(this.list_type);
    },

    // SNS×一覧種別のON/OFF状態
    item() {
      const m = this.$store.state.report_item_map || {};
      const byList = m[this.lt] || {};
      return byList[this.st] || {};
    },

    // backend column_list（titleで描画）
    fields() {
      const m = this.$store.state.report_column_list_map || {};
      const byList = m[this.lt] || {};
      const cols = byList[this.st];

      let list = Array.isArray(cols) ? cols : [];

      const scope = this.lt; // 'influencer' | 'post'
      list = list.filter((c) => {
        if (!c) return false;
        if (!Array.isArray(c.scopes) || c.scopes.length === 0) return true;
        return c.scopes.includes(scope);
      });

      if (this.lt === "influencer") {
        const hideCols = new Set(["caption", "comment", "timestamp"]);
        list = list.filter((c) => !(c && hideCols.has(c.column)));
      }

      list = list.filter((c) => c && c.column && c.title);
      list = list.filter((c) => c.configurable !== false);

      return list;
    },
  },
  methods: {
    shouldShowField(f) {
      if (!f || !f.column) return false;
      if (!f.title) return false;
      return true;
    },

    isDisabledField(f) {
      if (!f || !f.column) return false;
      return f.locked === true;
    },

    isChecked(key) {
      const f = (this.fields || []).find(x => x && x.column === key);
      if (f && f.locked === true) return true; // ←常にON
      return this.item[key] !== false;
    },

    onToggle(key, checked) {
      const f = (this.fields || []).find(x => x && x.column === key);
      if (f && f.locked === true) return;

      const next = { ...(this.item || {}) };
      next[key] = checked ? true : false;

      this.$store.dispatch("saveReportItems", {
        sns_type: this.st,
        list_type: this.lt,
        items: next,
      });
    },

    resetReportItems() {
      this.$store.dispatch("resetReportItems", {
        sns_type: this.st,
        list_type: this.lt,
      });
    },
  },
};
</script>

<style scoped>
.report-display-button-menu {
  max-height: 420px;
  overflow-y: auto;
}
</style>
